import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FeatureRecommendationState {
  feature: string | null;
}

const initialState: FeatureRecommendationState = {
  feature: null,
};

const featureRecommendationSlice = createSlice({
  name: "featureRecommendation",
  initialState: initialState,
  reducers: {
    setFeature: (state, action: PayloadAction<{ feature: string | null }>) => {
      state.feature = action.payload.feature;
      return state;
    },
    clearFeature: (state) => {
      state.feature = null;
      return state;
    },
  },
});

export const featureRecommendationActions = featureRecommendationSlice.actions;
export default featureRecommendationSlice;
